import { render } from "./PraxisgruppeEditAccountDialog.vue?vue&type=template&id=1df19786&ts=true"
import script from "./PraxisgruppeEditAccountDialog.vue?vue&type=script&lang=ts"
export * from "./PraxisgruppeEditAccountDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__